import React, { useState, useEffect } from "react";
import { shape } from "prop-types";
import { Row, Col, Button, Modal, Table, Skeleton, Popconfirm } from "antd";
import {
  PlusCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  RedoOutlined,
} from "@ant-design/icons";

import { getFieldbookQuery } from "@graphql/queries";
import { useDeletePesticide } from "@graphql/mutations";
import { formatDate } from "@utils/dateUtils";

import FieldbookPesticidesHistoric from "../FieldbookPesticidesHistoric";

import FieldbookPesticideForm from "./FieldbookPesticideForm";

const tableProps = {
  size: "middle",
  pagination: false,
  style: {
    marginBottom: 40,
  },
};

function FieldbookPesticides({ fieldbook }) {
  const [modalVisible, setModalVisible] = useState(false);
  const toggleModal = () => setModalVisible(!modalVisible);
  const [editableData, setEditableData] = useState();
  const [importHistoric, setImportHistoric] = useState(false);
  const toggleImportHistoric = () => setImportHistoric(!importHistoric);
  const [deletePesticide] = useDeletePesticide();
  const data = fieldbook.pesticides;

  const handleEdit = (record) => {
    setEditableData(record);
    setModalVisible(true);
  };

  const handleDelete = (id) => {
    deletePesticide({
      variables: { id },
      refetchQueries: [
        {
          query: getFieldbookQuery,
          variables: { id: fieldbook.id },
        },
      ],
    });
  };
  const columns = [
    {
      dataIndex: "date",
      title: "Data",
      render: formatDate,
    },
    {
      dataIndex: "area",
      title: "Área (ha)",
    },
    {
      dataIndex: "plantingWeeks",
      title: "Sem. Plantação",
    },
    {
      dataIndex: "product",
      title: "Produto",
      render: (value) => value?.name,
    },
    {
      dataIndex: "sauce",
      title: "Calda (lt / ha)",
    },
    {
      dataIndex: "provider",
      title: "Fornecedor",
      render: (value) => value?.name,
    },
    {
      dataIndex: "phenologicalState",
      title: "Estado Fenológico",
      render: (value) => value?.name,
    },
    {
      dataIndex: "safeHarvestDate",
      title: "Data Segura Colheita",
      render: formatDate,
    },
    {
      align: "center",
      render: (_, record) =>
        !fieldbook.isArchived && (
          <>
            <EditOutlined
              style={{ marginRight: 10 }}
              onClick={() => handleEdit(record)}
            />

            <Popconfirm
              title="Tem a certeza que quer eliminar este fitofármaco?"
              onConfirm={() => handleDelete(record.id)}
              okText="Sim"
              cancelText="Não"
            >
              <DeleteOutlined />
            </Popconfirm>
          </>
        ),
    },
  ];

  useEffect(() => {
    if (!modalVisible) {
      setEditableData();
    }
  }, [modalVisible]);

  return (
    <>
      {!fieldbook.isArchived && (
        <>
          <Modal
            title={`${editableData ? "Editar" : "Criar"} fitofármaco`}
            visible={modalVisible}
            onCancel={() => toggleModal()}
            footer={null}
            width={900}
            centered
          >
            <FieldbookPesticideForm
              data={fieldbook}
              afterSubmit={() => toggleModal()}
              editableData={editableData}
            />
          </Modal>

          <Modal
            title="Histórico de Fitofármacos"
            width="90%"
            footer={null}
            onCancel={toggleImportHistoric}
            visible={importHistoric}
          >
            <FieldbookPesticidesHistoric
              fieldbookId={fieldbook.id}
              afterSubmit={toggleImportHistoric}
              producersIds={fieldbook?.producers?.map(
                ({ producer }) => producer.id
              )}
            />
          </Modal>

          <Row style={{ marginTop: 30 }}>
            <Col md={24} style={{ textAlign: "right" }}>
              <Button
                icon={<RedoOutlined />}
                onClick={toggleImportHistoric}
                style={{ marginRight: 10 }}
              >
                Importar Histórico
              </Button>

              <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                onClick={() => toggleModal()}
              >
                Fitofármaco
              </Button>
            </Col>
          </Row>
        </>
      )}

      <br />

      <Skeleton loading={!data} active>
        {data && (
          <Table
            columns={columns}
            dataSource={data}
            rowKey={({ id }) => id}
            rowClassName={() => "editable-row"}
            pagination={false}
            {...tableProps}
          />
        )}
      </Skeleton>
    </>
  );
}

FieldbookPesticides.propTypes = {
  fieldbook: shape({}).isRequired,
};

export default FieldbookPesticides;
